// Funds

import { requestHandler } from '../../api';

export const getCompanyFunds = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund`,
    dispatch,
  });
  if (response) return response.data;
};

export const createFund = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getFund = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteFund = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/fund/${data.id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFund = async (dispatch: any, id: string, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/fund/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const selectFundAsDefault = async (dispatch: any, id: string) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/fund/${id}/selectAsDefault`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsAssignedToFund = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/documents`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentForAssignation = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/documents/available`,
    dispatch,
  });
  if (response) return response.data;
};

export const assignDocumentToFund = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/${data.id}/documents/assign`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getFundPayments = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/payments`,
    dispatch,
  });
  if (response) return response.data;
};

export const createFundPayments = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/payments`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createFundInvoicesBuyBack = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/buy-back`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createFundOwnCollection = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/own-collection`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFundPayment = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/fund/${data.id}/payments/${data.paymentId}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getPaymentSuggestions = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/fund/${data.id}/payments/suggestions`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFactoringResellsArrear = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/documents/arrears`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const createFactoringResellPendingAccounts = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/fund/documents/pending-accounts`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
